import { t, locale } from "@/lib/i18n";

export function money(minor, currency) {
  return `${currency} ${(minor / 100).toLocaleString(locale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function amountMinor(text) {
  if (!/^\d+(\.\d{1,2})?$/.test(String(text))) throw new Error(t("Enter an amount with at most two decimal places."));
  const [whole, fraction = ""] = String(text).split(".");
  const result = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
  if (!Number.isSafeInteger(result) || result < 1) throw new Error(t("Enter a positive payment amount."));
  return result;
}

export function billingLabel(plan) {
  return plan.plan_type === "permanent" ? t({ monthly: "Monthly", half_yearly: "Half-yearly", yearly: "Yearly" }[plan.payment_frequency])
    : t("One-time payment · {0} {1}", { 0: plan.duration, 1: t(plan.duration_unit === "days" ? "days" : "months") });
}

export function dateLabel(value) {
  return new Date(value).toLocaleString(locale());
}
